/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { integrationsIntegrationsNumberGet } from "../funcs/integrationsIntegrationsNumberGet.js";
import { integrationsList } from "../funcs/integrationsList.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { GetIntegrationResult } from "../models/components/getintegrationresult.js";
import { ListIntegrationsResult } from "../models/components/listintegrationsresult.js";
import {
  IntegrationsNumberGetRequest,
  IntegrationsNumberGetSecurity,
} from "../models/operations/integrationsnumberget.js";
import {
  ListIntegrationsRequest,
  ListIntegrationsSecurity,
} from "../models/operations/listintegrations.js";
import { unwrapAsync } from "../types/fp.js";

export class Integrations extends ClientSDK {
  /**
   * get integrations
   *
   * @remarks
   * Get a third-party integration by ID or name.
   */
  async integrationsNumberGet(
    request?: IntegrationsNumberGetRequest | undefined,
    security?: IntegrationsNumberGetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetIntegrationResult> {
    return unwrapAsync(integrationsIntegrationsNumberGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * list integrations
   *
   * @remarks
   * List available third-party integrations.
   */
  async list(
    request?: ListIntegrationsRequest | undefined,
    security?: ListIntegrationsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListIntegrationsResult> {
    return unwrapAsync(integrationsList(
      this,
      request,
      security,
      options,
    ));
  }
}
